import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { Authorize } from '@/core';
import { Button } from 'antd';
import React from 'react';
import { WardProvider } from '../context';
import { DetailDistrict } from './Form';
import { WardTable } from './List/WardTable';
import { PERMISSIONS } from '@/contants';

export const WardScreen: React.FC = () => {
  const { open, handleClose, setOpen, handleClickCreate } = useHandleActionItem();

  return (
    <WardProvider>
      <div className='bg-white py-4 px-4 flex flex-col flex-wrap'>
        <div className='ml-auto'>
          <Button
            type='primary'
            size='middle'
            onClick={() => handleClickCreate()}
            className='rounded'
          >
            + Create
          </Button>
        </div>
        <div className='w-full mt-2'>
          <WardTable />
          <DetailDistrict open={open} handleClose={handleClose} setOpen={setOpen} />
        </div>
      </div>
    </WardProvider>
  );
};

export const WardList = Authorize(WardScreen, PERMISSIONS.WARDS.VIEW);
